import React, { useEffect, useState } from "react";

import { cn } from "@/shared/lib/cn";

/* Folds its children shut and open, growing to their height and back rather than jumping: grid
   rows 0fr → 1fr over 400ms, easing in and out (--easing's fast start would leap a tall body in
   its first frame). Shut, it is `inert`. Once open and settled it stops clipping, so the ring and
   shadow of a card inside it draw whole; its one column is `minmax(0, 1fr)`, so no unbroken
   line inside it (a command, an address) ever widens it past its parent. */
export default function Fold({ open, className, children }: { open: boolean; className?: string; children?: React.ReactNode }) {
  const [settled, setSettled] = useState(open);
  useEffect(() => {
    if (!open) setSettled(false);
  }, [open]);
  return (
    <div
      inert={!open}
      onTransitionEnd={(e) => {
        if (open && e.target === e.currentTarget) setSettled(true);
      }}
      className={cn(
        "grid grid-cols-1 transition-[grid-template-rows,opacity] [transition-duration:400ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
        open ? "grid-rows-[1fr]" : "grid-rows-[0fr] opacity-0",
        className,
      )}
    >
      <div className={cn("min-h-0 min-w-0", settled ? "overflow-visible" : "overflow-hidden")}>{children}</div>
    </div>
  );
}
